export var CodeblockVariant;
(function (CodeblockVariant) {
    CodeblockVariant["ENHANCED"] = "enhanced";
    CodeblockVariant["NO_LINE_NUMBERS"] = "no-line-numbers";
    CodeblockVariant["LEGACY"] = "legacy";
})(CodeblockVariant || (CodeblockVariant = {}));
